import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUploadsBaseUrl } from '../../../../api/axiosInstance';
import { Spinner, Figure, FormControl } from 'react-bootstrap';
import placeholder from '../../../../assets/images/placeholder32x32.png';
import { IoIosClose } from 'react-icons/io';
import ConfirmPopOver from '../../../common/ConfirmPopOver';

function CartContents(props) {
    const { t } = useTranslation();
    const { cartOrder, orderRowsMeta, removeProductFromCart, setProductQuantity, partnerPortalSettings, checkout } = props;

	const getStatus = (status) => {
		if (orderRowsMeta && orderRowsMeta.statuses && orderRowsMeta.statuses.partner) {
			orderRowsMeta.statuses.partner.forEach((metaStatus)=>{
				if (metaStatus.id === status) {
					status = t('orders.order_row_status') +  ': ' + metaStatus.name;
				}
			})
		}
		return status
    };

    // round at most 2 decimal places if necessary (?)
    const round = number => Math.round((number + Number.EPSILON) * 100) / 100;

    const getTotalWithoutTaxRounded = (cartOrder) => {
        var totalWithoutTaxRounded = 0;

		cartOrder.orderRows.forEach((orderRow) => {
			if (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) {
				if (checkout) {
					totalWithoutTaxRounded += Number(orderRow.priceWithoutTaxRounded) * orderRow.productCount;
				} else {
					if (orderRow.status === 5) {
						totalWithoutTaxRounded += Number(orderRow.priceWithoutTaxRounded) * orderRow.productCount;
					}
				}
			} else {
				totalWithoutTaxRounded += Number(orderRow.priceWithoutTaxRounded) * orderRow.productCount;
			}
        });
        
		return round(totalWithoutTaxRounded);
	};

	const getTotalWithTaxRounded = (cartOrder) => {
        var totalWithTaxRounded = 0;
        
		cartOrder.orderRows.forEach((orderRow) => {
			if (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) {
				if (checkout) {
					totalWithTaxRounded += Number(orderRow.totalPriceIncludingProductCount);
				} else {
					if (orderRow.status === 5) {
						totalWithTaxRounded += Number(orderRow.totalPriceIncludingProductCount);
					}
				}
			} else {
				totalWithTaxRounded += Number(orderRow.totalPriceIncludingProductCount);
			}

        });

		return round(totalWithTaxRounded);
    };

    return (
        <div>
            { !cartOrder.loading ?
                <div className="orderRowContainer">
                    { cartOrder && cartOrder.orderRows
                        .filter(orderRow => orderRow.status === 3 || orderRow.status === 4 || orderRow.status === 5)
                        .map(orderRow =>
                            <div key={orderRow.orderRowID}>
                                {(checkout ? true : (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) ? orderRow.status === 5 : true) ?
                                    <div className="orderRow">
                                        <Figure className="orderRowImage">
                                            {
                                                orderRow.product.productsMaterials &&
                                                orderRow.product.productsMaterials[0] ?
                                                <Figure.Image
                                                    width={32}
                                                    height={32}
                                                    rounded={true}
                                                    src={getUploadsBaseUrl() + orderRow.product.productsMaterials[0].material.absolutePath + '_XS'}
                                                /> :
                                                <Figure.Image
                                                    width={32}
                                                    height={32}
                                                    rounded={true}
                                                    src={placeholder}
                                                />
                                            }
                                        </Figure>
                                        <div className="orderRowContent">
                                            <h4 className="orderRowTitle">
                                                <span>
                                                    {!orderRow.productBundleID && orderRow.status === 5 &&
                                                        <ConfirmPopOver
                                                            placement="left"
                                                            title={t('products.remove_from_cart_prompt')}
                                                            onConfirm={() => removeProductFromCart(orderRow.orderRowID)}
                                                            confirmText={t('general.yes')}
                                                            cancelText={t('general.no')}
                                                            triggerElement={
                                                                <button className="removeProductBtn" variant="light">
                                                                    <IoIosClose className="removeBtn" />
                                                                </button>
                                                            }
                                                        />
                                                    }
                                                    <span>{orderRow.product.name || ''}</span>
                                                </span>
                                            </h4>
                                            <div className="orderRowDescription">
                                            {!orderRow.productBundleID && orderRow.status === 5 ?
                                                    <div style={{paddingBottom:4}} key={orderRow.productCount}>
                                                        <FormControl
                                                            className={"productRowCount"}
                                                            size="small"
                                                            type={"number"}
                                                            min={1}
                                                            max={orderRow.product.stock || 99999}
                                                            defaultValue={orderRow.productCount || 1}
                                                            onBlur={(e) => setProductQuantity(orderRow.productID, e.target.value, orderRow.orderRowID)}
                                                        />
                                                        { orderRow.product &&
                                                            <span className={"orderRowUnitType"}>
                                                                {orderRow.product.unitType || 'kpl'}
                                                            </span>
                                                        }
                                                    </div>
                                                    :
                                                    <div>
                                                        {orderRow.productCount || 1}
                                                        { orderRow.product &&
                                                            <span className={"orderRowUnitType"}>
                                                                {orderRow.product.unitType || 'kpl'}
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                                {orderRow.productBundleID &&
                                                    <span>{orderRow.productCount || 1} {orderRow.unitType || 'kpl'} - ({t('orders.bundle')})</span>
                                                }
                                                {<span className={"totalPrice"}>{orderRow.totalPriceIncludingProductCount + '€'}</span>}
                                                {<span>{getStatus(orderRow.status)}</span>}
                                            </div>
                                        </div>
                                    </div>
                                : null}
                            </div>
                    )}
                </div>
                :
                <div className="text-center" style={{ padding: '30px'}}>
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            }

            {!!cartOrder.orderRows.length &&
                <div className={"priceContainer " + (checkout ? 'noBorders' : '')}>
                    <p>{t('orders.total_price_w/o_tax')} <span className={"priceSpan"}>{getTotalWithoutTaxRounded(cartOrder)}€</span></p>
                    <p>{t('products.tax_included')} <span className={"priceSpan"}>{getTotalWithTaxRounded(cartOrder)}€</span></p>
                    <p>{t('orders.total')} <span className={"priceSpan"}><strong>{getTotalWithTaxRounded(cartOrder)}€</strong></span></p>
                </div>
            }
            {!cartOrder.orderRows.length &&
                <div className={"priceContainer emptyCart " + (checkout ? 'noBorders' : '')}>
                    <p>{t('products.empty_cart')}</p>
                </div>
            }
        </div>
    );
}

export default CartContents;